module.exports = __webpack_public_path__ + "img/news1.c8d83b63.png";